import i18n from '@/app-shared/i18n';
export function getCheckList() {
  return [
    {
      use: true,
      name: 'video',
      text: `${i18n.t('host.k_654001')}`,
      icon: 'vh-line-detection',
      status: 'no-check'
    },
    {
      use: true,
      name: 'audioInput',
      text: `${i18n.t('host.k_654002')}`,
      icon: 'vh-line-microphone',
      status: 'no-check'
    },
    {
      use: true,
      name: 'audioOutput',
      text: `${i18n.t('host.k_654003')}`,
      icon: 'vh-line-voice',
      status: 'no-check'
    }
  ];
}
